<section class="stats-page">
  <header class="page-header">
    <div>
      <h1>Statistiques produit</h1>
      <p>Vue globale de l’activité utilisateurs, contenu et modération.</p>
    </div>
    <button type="button" class="ghost" (click)="reload()" [disabled]="loading">Rafraîchir</button>
  </header>

  <p class="message error" *ngIf="errorMessage">{{ errorMessage }}</p>
  <div class="state loading-state" *ngIf="loading">
    <span class="spinner" aria-hidden="true"></span>
    <span>Chargement…</span>
  </div>

  <ng-container *ngIf="!loading && stats">
    <section class="kpis">
      <article>
        <strong>{{ stats.usersCount }}</strong>
        <span>Utilisateurs</span>
      </article>
      <article>
        <strong>{{ stats.enabledUsersCount }}</strong>
        <span>Comptes actifs</span>
      </article>
      <article>
        <strong>{{ stats.anonymousUsersCount }}</strong>
        <span>Comptes anonymes</span>
      </article>
      <article>
        <strong>{{ stats.categoriesCount }}</strong>
        <span>Catégories</span>
      </article>
      <article>
        <strong>{{ stats.recipesCount }}</strong>
        <span>Recettes</span>
      </article>
      <article>
        <strong>{{ stats.inspirationsCount }}</strong>
        <span>Inspirations</span>
      </article>
      <article>
        <strong>{{ stats.openReportsCount }}</strong>
        <span>Signalements ouverts</span>
      </article>
    </section>

    <section class="panel">
      <h2>Modération</h2>
      <div class="bars">
        <article>
          <div class="label">
            <span>Recettes approuvées</span>
            <strong>{{ ratio(stats.approvedRecipesCount, stats.recipesCount) }}%</strong>
          </div>
          <div class="bar"><span [style.width.%]="ratio(stats.approvedRecipesCount, stats.recipesCount)"></span></div>
        </article>
        <article>
          <div class="label">
            <span>Recettes en review</span>
            <strong>{{ ratio(stats.recipesInReviewCount, stats.recipesCount) }}%</strong>
          </div>
          <div class="bar"><span class="warn" [style.width.%]="ratio(stats.recipesInReviewCount, stats.recipesCount)"></span></div>
        </article>
        <article>
          <div class="label">
            <span>Inspirations en review</span>
            <strong>{{ ratio(stats.inspirationsInReviewCount, stats.inspirationsCount) }}%</strong>
          </div>
          <div class="bar">
            <span class="warn" [style.width.%]="ratio(stats.inspirationsInReviewCount, stats.inspirationsCount)"></span>
          </div>
        </article>
        <article>
          <div class="label">
            <span>Messages d’avis en review</span>
            <strong>{{ stats.reviewMessagesInReviewCount }}</strong>
          </div>
        </article>
      </div>
    </section>
  </ng-container>
</section>
